import {Client} from '../../../graphql/types'

const AFFILIATE_ID = 36667

export const overrideFor36667 = (accounts: any[], client: Client) => {
  if (client.affiliateId !== AFFILIATE_ID) return accounts

  return accounts.filter(account => !['black', 'raw', 'mt5Raw', 'mt5Vip'].includes(account.accountSubtype))
}
